export const RecurringIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 0.499999L1.625 0.5L1.625 2.73437L1.90937 2.40937C2.53229 1.70521 3.24323 1.21094 4.04219 0.926562C4.84115 0.642187 5.64687 0.5 6.45937 0.5C7.9625 0.5 9.29974 0.95026 10.4711 1.85078C11.6424 2.7513 12.4177 3.92604 12.7969 5.375L11.0906 5.375C10.7385 4.4 10.1393 3.61458 9.29297 3.01875C8.44661 2.42292 7.50208 2.125 6.45937 2.125C5.85 2.125 5.25755 2.2401 4.68203 2.47031C4.10651 2.70052 3.575 3.05937 3.0875 3.54687L2.88438 3.75L4.875 3.75L4.875 5.375L-2.13093e-07 5.375L0 0.499999ZM0.203125 8.625L1.90937 8.625C2.26146 9.6 2.86068 10.3854 3.70703 10.9813C4.55339 11.5771 5.49792 11.875 6.54062 11.875C7.15 11.875 7.74245 11.7599 8.31797 11.5297C8.89349 11.2995 9.425 10.9406 9.9125 10.4531L10.1156 10.25L8.125 10.25L8.125 8.625L13 8.625L13 13.5L11.375 13.5L11.375 11.2656L11.0906 11.5906C10.4271 12.2542 9.70599 12.7383 8.92734 13.043C8.1487 13.3477 7.35312 13.5 6.54062 13.5C5.0375 13.5 3.70026 13.0497 2.52891 12.1492C1.35755 11.2487 0.582291 10.074 0.203125 8.625Z"
      fill="#5C666B"
    />
  </svg>
);
